import { useTheme } from "@/theme/ThemeProvider";
import { Stack } from "expo-router";

export default function CalendarLayout() {
  const { theme } = useTheme();
  return (
    <Stack
      screenOptions={{
        headerShown: false,
        contentStyle: { backgroundColor: theme.color.bg },
      }}
    >
      <Stack.Screen name="index" />
      <Stack.Screen name="[itemId]" />
    </Stack>
  );
}
